export default "__VITE_ASSET__1a127511__"